module.exports = __webpack_public_path__ + "img/download-qrcode.73b82ec4.png";